import * as React from 'react';
import { connect } from 'react-redux';

import DropdownButton from '../ui/DropdownButton';
import RecommendationInfo from '../ui/Modal/RecomendationInfo';
import { IHandlers } from '../../services/ApiClient';
import { getRecommendations, onPlageSearch } from '../../actions';

interface ActionsProps {
  schema: any;
  extRules: any;
  mode: string;
  progress: number;
  form_type: string;
  settings: any;
  userRole: string;
  process_id: number;
  isVisible: boolean;
  status: number;
  isPdf: boolean;
  onSend: () => void;
  onPDF: () => void;
  onDraft: () => void;
  onDocument: (properties: {
    comment?: boolean;
    personal?: boolean;
    title?: string;
    sendType?: string;
  }) => void;
  onRevoke: (comment?: boolean, personal?: boolean, title?: string) => void;
  onReturn: (customLink?: string) => void;
  onDelete: () => void;
  onCopy: (lastComment?: string) => void;
  onLastComment: (lastComment?: string, lastCommentColor?: string) => void;
  onAddition: () => void;
  sectionIndex: number;
  onSetSectionForIndex: (arg: number) => void;
  sectionCount: number;
  values: Array<{ controlid: string; value: any }>;
  availableActions: Record<string, boolean>;
}

interface DispatchProps {
  onPlageSearch?: any;
  getRecommendations?: any;
}

interface ActionState {
  send: string;
  revoke: string;
  comment: any;
  visible: string[];
  lastComment?: string;
  lastCommentColor?: string;
  showOnLoad?: boolean;
  revokeColor?: string;
  rateQualityModalActive?: boolean;
}

class Actions extends React.Component<
  ActionsProps & DispatchProps,
  ActionState
> {
  componentWillMount() {
    this.setState({
      ...this.props.extRules.ActionsDefaultState,
      rateQualityModalActive: false,
    });
  }

  componentDidMount(): void {
    this.setStatus();
  }

  componentDidUpdate(
    prevProps: Readonly<ActionsProps>,
    prevState: Readonly<ActionState>,
    prevContext: any,
  ): void {
    const { status, userRole } = this.props;
    if (prevProps.status !== status || prevProps.userRole !== userRole) {
      this.setStatus();
    }
  }

  setStatus = () => {
    const {
      status,
      userRole,
      extRules: { ActionsRules },
    } = this.props;
    if (ActionsRules?.[userRole] && ActionsRules?.[userRole]?.[status]) {
      const initialState = { ...ActionsRules[userRole][status] };
      this.setState({ ...initialState });
    } else {
      this.setState({ ...ActionsRules.user['7'] });
    }
  };

  handlerRateQuality = () => {
    this.setState(({ rateQualityModalActive }) => ({
      rateQualityModalActive: !rateQualityModalActive,
    }));
  };

  isEnglishVersionAvailable = () => {
    const { values } = this.props;
    const enFieldValue = values.find(
      (value) => value.controlid === 'enFieldsAvailable',
    );
    if (enFieldValue && enFieldValue.value === '1') {
      return true;
    } else return false;
  };

  render() {
    const {
      mode,
      settings,
      onSetSectionForIndex,
      sectionIndex,
      sectionCount,
      values,
    } = this.props;
    const {
      send,
      revoke,
      visible,
      comment,
      lastComment,
      lastCommentColor,
      revokeColor,
      rateQualityModalActive,
    } = this.state;

    const isEnAvailable = this.isEnglishVersionAvailable();

    return (
      <>
        <div className="reportbox-actions">
          <div className="note">
            {mode === 'suspended' && (
              <span style={{ color: 'red' }}>
                Приём заявок временно приостановлен
              </span>
            )}
            {mode === 'working' && (
              <span>Данные заявки сохраняются автоматически</span>
            )}
          </div>

          <div className="btn-content">
            <div className="btn-group" role="group" style={{ marginRight: 20 }}>
              <button
                type="button"
                onClick={() => {
                  if (sectionIndex) {
                    onSetSectionForIndex(sectionIndex - 1);
                  }
                }}
                className="btn btn-default"
                disabled={!sectionIndex}
                style={{ margin: 0, color: 'black' }}
              >
                Предыдущая
              </button>
              <button
                type="button"
                onClick={() => {
                  if (sectionCount !== sectionIndex + 1) {
                    onSetSectionForIndex(sectionIndex + 1);
                  }
                }}
                className="btn btn-default"
                disabled={sectionCount === sectionIndex + 1}
                style={{ margin: 0, color: 'black' }}
              >
                Следующая
              </button>
            </div>

            <button
              className="btn btn-backbutton btn-sm pull-right"
              onClick={() => {
                this.props.onReturn();
              }}
            >
              Назад к списку заявок
            </button>

            <button
              className="btn btn-default"
              style={{ color: 'black' }}
              onClick={() => this.handlerRateQuality()}
            >
              Проверить
            </button>

            {/*{lastComment && (*/}
            {/*  <button*/}
            {/*    className="btn btn-sm pull-right btn-primary"*/}
            {/*    onClick={*/}
            {/*      this.props.onLastComment.bind(this, lastComment, lastCommentColor)}*/}
            {/*      style={lastCommentColor ? {backgroundColor: lastCommentColor, borderColor: lastCommentColor} : {}}>*/}
            {/*    {lastComment}*/}
            {/*  </button>*/}
            {/*)}*/}

            {/*{visible.indexOf('revoke') > -1 && (*/}
            {/*  <button*/}
            {/*    className="btn btn-sm btn-bordered pull-right"*/}
            {/*    onClick={*/}
            {/*      this.props.onRevoke.bind(*/}
            {/*        this,*/}
            {/*        visible.indexOf('comment/revoke') > -1,*/}
            {/*        visible.indexOf('personal/revoke') > -1, !comment?.revoke ? comment : comment.revoke*/}
            {/*      )*/}
            {/*    }*/}
            {/*    style={revokeColor ? { backgroundColor: revokeColor, borderColor: revokeColor } : {}}*/}
            {/*  >*/}
            {/*    {revoke}*/}
            {/*  </button>*/}
            {/*)}*/}

            {/*{visible.indexOf('send') > -1 && (*/}
            {/*  <button className="btn btn-success btn-sm pull-right" onClick={this.props.onDocument.bind(this, visible.indexOf('comment/send') > -1, visible.indexOf('personal/send') > -1, isUndefined(comment.send) ? comment : comment.send) }>*/}
            {/*    {send}*/}
            {/*  </button>*/}
            {/*)}*/}

            {visible.indexOf('send') > -1 && (
              /*@ts-ignore*/
              <DropdownButton
                settings={settings}
                onDocument={this.props.onDocument}
                onRevoke={this.props.onRevoke}
                formType={this.props.form_type}
                processId={this.props.process_id}
                isEnglishVersionAvailable={isEnAvailable}
                availableActions={this.props.availableActions}
              />
            )}
          </div>
        </div>

        <RecommendationInfo
          isOpen={rateQualityModalActive}
          onHide={this.handlerRateQuality}
          onPlageSearch={this.props.onPlageSearch}
          getRecommendations={this.props.getRecommendations}
        />
      </>
    );
  }
}

const mapDispatchToProps = (dispatch): DispatchProps => ({
  onPlageSearch: (handlers: IHandlers) => {
    dispatch(onPlageSearch(handlers));
  },
  getRecommendations: (handlers: IHandlers) => {
    dispatch(getRecommendations(handlers));
  },
});

const mapStateToProps = (state) => ({
  settings: state.forms.settings,
  values: state.forms.values,
  availableActions: state.forms.form.availableActions,
});

export default connect(mapStateToProps, mapDispatchToProps)(Actions);
